import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState: { value: { isPlaying: boolean, progress: number }, isLoading: boolean } = {
  value: { isPlaying: false, progress: 0 },
  isLoading: false
}

const audioSlice = createSlice({
  initialState,
  name: "audio_slice",
  reducers: {
    set_is_playing: (state, action: PayloadAction<boolean>) => {
      state.value.isPlaying = action.payload
    },
    set_progress: (state, action: PayloadAction<number>) => {
      state.value.progress = action.payload
    },
    set_loading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    }
  }
})

export const { set_is_playing, set_progress, set_loading } = audioSlice.actions
export const audio_slice = audioSlice.reducer